import { apiService } from './axios.client';

export const DesignEndPoints = {
    convertToSVG: function (file, callback) {
        const formData = new FormData();
        formData.append('file', file);
    
        apiService.post('/drawing/ConvertToSVG', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => callback(response.data))
        .catch(error => {
          if (error.response) {
            callback(null, error.response.data);
          } else {
            callback(null, error.message);
          }
        });
    },
    convertToPNG: function (file, callback) {
      const formData = new FormData();
      formData.append('file', file);
  
      apiService.post('/drawing/ConvertToPNG', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => callback(response.data))
      .catch(error => {
        if (error.response) {
          callback(null, error.response.data);
        } else {
          callback(null, error.message);
        }
      });
    },
    exportToDWG: function (input, callback) {
    
      const formData = new FormData();
      formData.append('File', input.file);
      formData.append('SVG', input.svg);
      apiService.post('/drawing/ExportToDWG', formData, { responseType: 'blob' })
      .then(response => callback(response))
      .catch(error => {
        if (error.response) {
          callback(null, error.response.data);
        } else {
          callback(null, error.message);
        }
      });
    },
    loadDrawing: function (input, callback) {
      apiService.get('/drawing/LoadDrawing', {
        headers: {
          'id': input
        }
      })
      .then(response => callback(response.data))
      .catch(error => {
        if (error.response) {
          callback(null, error.response.data);
        } else {
          callback(null, error.message);
        }
      });
    },
    loadDrawings: function (callback) {
      apiService.get('/drawing/loadDrawings')
      .then(response => callback(response.data))
      .catch(error => {
        if (error.response) {
          callback(null, error.response.data);
        } else {
          callback(null, error.message);
        }
      });
    },
    deleteDrawing: function (input, callback) {
      apiService.get('/drawing/DeleteDrawing', {
        headers: {
          'id': input
        }
      })
      .then(response => callback(response.data))
      .catch(error => {
        if (error.response) {
          callback(null, error.response.data);
        } else {
          callback(null, error.message);
        }
      });
    },
};